// extracted by mini-css-extract-plugin
module.exports = {"root":"_23b7e5","header":"_4834f5","logoContainer":"_51005d","logo":"_1209fe","truncatedText":"_fe7838","primaryCta":"_c4a212"};